<audio id="audio" (timeupdate)="updateProgress()" (ended)= "setPlayButton()" #audiolayer>
	<source src="{{audiofile}}" type="audio/mpeg">
</audio>
<div class="player">
	<div class="controls-wrapper">
		<ion-grid class="ion-no-padding">
			<ion-row>
				<ion-col size="1">
					<button (click)="play()" [ngClass] = "{'play': !playing, 'pause': playing}"></button>
				</ion-col>
				<ion-col size="8" col-sm-10>
					<progress (click) = "jump($event)" value="0" max="1" class="progress" #progress></progress>
					<div class="dot" #dot></div>
				</ion-col>
				<ion-col size="3" ion-col-sm-1>
					<div class="volume">
						<span class="volume-minus" (click) = "decreaseVolume()"><img src="/assets/img/pb-icon_audio_volume_lower.svg"></span>
						<span class="volume-icon"><img src="/assets/img/pb-icon_audio_volume_speaker.svg"></span>
						<span class="volume-plus" (click) = "increaseVolume()"><img src="/assets/img/pb-icon_audio_volume_higher.svg"></span>
					</div>
				</ion-col>
			</ion-row>
		</ion-grid>
	</div>
</div>
